module.exports = "/_next/static/images/buyers_5-512a43966306f7ce5b2be987d7a2c0e8.png";